import React, { Component } from "react";
import ApprovalFlowForm from "../ApprovalFlowForm/ApprovalFlowForm";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : ApprovalFlowPage
Description : Componente que invoca al componente ApprovalFlowForm
Date Autor Modification
================================================================================
14/04/2026 scoca – Creacióm
================================================================================ */
class ApprovalFlowPage extends Component {
    render() {
        return (
            <ApprovalFlowForm />
        )
    }
}

export default ApprovalFlowPage;